<template>
  <div class="wt-symbol-gallery wt2-sg -custom-css">
    <wt-grid-images-gallery
      type="symbol-type"
      :selected-option-id="galleryValueId"
      :options="normalizeOptions"
      :number-of-lines="field.numberOfLines || 3"
      :number-of-cols="field.numberOfCols || 5"
      @click="changeGalleryValue"
      @gallery-ready="fieldReady"
    >
      <div class="-gallery-header" slot="header">
        <div class="-label-box" v-if="field.label">
          <span class="wt2-text-n wt2-color-normal">{{ field.label }}</span>
        </div>
        <slot name="tooltip"></slot>
      </div>
    </wt-grid-images-gallery>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(['optionThumbnails'], (prop) =>
          _.includes(_.keys(value), prop)
        );
      },
    },
  },

  mixins: [fieldsMixin],

  data() {
    return {
      galleryValueId: null,
    };
  },

  computed: {
    normalizeOptions() {
      return _.map(this.field.optionThumbnails, (option, i) => {
        return {
          id: option.id,
          src: this.getSrc(i, option.thumbnail),
        };
      });
    },
  },

  created() {
    this.galleryValueId = _.isDefined(this.field.value)
      ? this.field.value
      : this.field.defaultValue ||
        (this.field.optionThumbnails &&
          this.field.optionThumbnails[0] &&
          this.field.optionThumbnails[0].id);
    this.emitChange({ newValue: this.galleryValueId, makeDirty: false });
    this.$watch('galleryValueId', (newValue) => {
      this.emitChange({ newValue });
    });
  },

  methods: {
    changeGalleryValue(galleryValueId) {
      this.galleryValueId = galleryValueId;
    },

    getSrc(index, thumbnailSrc) {
      return app.DEFAULT.widgetThumbnails.format(thumbnailSrc) + '.png';
    },
  },
};
</script>
